import { Controller } from '@hotwired/stimulus'

// Sets an element's height to fit its content on first render.
// Skips if an inline height is already present (i.e. the user has dragged it),
// which admin-morph-preserve keeps across a broadcast. Pair with `overflow-auto resize-y`.
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      if (!this.element.style.height) this.fit()
    })
  }

  fit() {
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
